import dayjs from 'dayjs'
import 'dayjs/locale/th'
import { isNumber } from './Data'
import moment from 'moment'
dayjs.extend(require('dayjs/plugin/buddhistEra'))

export const yearList = [
  { calendar: 'BE', value: 543, label: 'พ.ศ.' },
  { calendar: 'AD', value: 0, label: 'ค.ศ.' },
]
export const dateBEFormatList = [
  { value: 'DD/MM/BBBB', label: 'DD/MM/BBBB', maskSign: '/' },
  { value: 'BBBB-MM-DD', label: 'BBBB-MM-DD', maskSign: '-' },
]

export const dateADFormatList = [
  { value: 'DD/MM/YYYY', label: 'DD/MM/YYYY', maskSign: '/' },
  { value: 'YYYY-MM-DD', label: 'YYYY-MM-DD', maskSign: '-' },
]

export const hourList = [
  { value: false, label: '24 Hours' },
  { value: true, label: 'AM/PM' },
]

export const format12hr = [
  { value: 'hh:mm:ss A', label: 'hh:mm:ss A', maskSign: ':' },
  { value: 'hh:mm A', label: 'hh:mm A', maskSign: ':' },
  { value: 'mm:ss', label: 'mm:ss', maskSign: ':' },
  { value: 'hh', label: 'Hours', maskSign: '' },
  { value: 'mm', label: 'Minutes', maskSign: '' },
  { value: 'ss', label: 'Seconds', maskSign: '' },
]

export const format24hr = [
  { value: 'HH:mm:ss', label: 'HH:mm:ss', maskSign: ':' },
  { value: 'HH:mm', label: 'HH:mm', maskSign: ':' },
  { value: 'mm:ss', label: 'mm:ss', maskSign: ':' },
  { value: 'HH', label: 'Hours', maskSign: '' },
  { value: 'mm', label: 'Minutes', maskSign: '' },
  { value: 'ss', label: 'Seconds', maskSign: '' },
]

export const DEFAULT_DATE = {
  current: moment().format('YYYY-MM-DD'),
  firstDateOfYear: moment().startOf('year').format('YYYY-MM-DD'),
  firstDateOfLastMonth: moment().startOf('month').format('YYYY-MM-DD'),
  firstDateOfMonth: moment().startOf('month').format('YYYY-MM-DD'),
  lastDateOfMonth: moment().endOf('month').format('YYYY-MM-DD'),
}

export const DEFAULT_TIME = {
  current: moment().format('HH:mm:ss'),
}

export const DEFAULT_DATETIME = {
  current: moment().format('YYYY-MM-DD HH:mm:ss'),
}

const getDateTimeValue = (dateTime) => {
  if (dateTime && typeof dateTime === 'object' && 'value' in dateTime) {
    return dateTime.value
  }
  return dateTime
}

export const getDateTimeFormValue = (dateTime, timestamp = false) => {
  const value = getDateTimeValue(dateTime)
  if (value === undefined || value === null || value === '') return null

  const date = moment(value)
  if (!date.isValid()) return null

  return timestamp
    ? date.format('YYYY-MM-DDTHH:mm:ss.SSSZ')
    : date.format('YYYY-MM-DD HH:mm:ss')
}

export const getDateFormatList = (calendar) => {
  return calendar === 'BE' ? dateBEFormatList : dateADFormatList
}

export const getTimeFormatList = (ampm) => {
  return ampm === true ? format12hr : format24hr
}

export const calDate = (date1, date2) => {
  const start = new Date(date1)

  const yearStart = start.getFullYear()
  const monthStart = start.getMonth()
  const dateStart = start.getDate()

  const end = date2 ? new Date(date2) : new Date()

  const yearEnd = end.getFullYear()
  const monthEnd = end.getMonth()
  const dateEnd = end.getDate()

  let year = yearEnd - yearStart
  let month

  if (monthEnd >= monthStart) {
    month = monthEnd - monthStart
  } else {
    year--
    month = 12 + monthEnd - monthStart
  }

  let day
  if (dateEnd >= dateStart) {
    day = dateEnd - dateStart
  } else {
    month--
    day = 31 + dateEnd - dateStart

    if (month < 0) {
      month = 11
      year--
    }
  }
  return {
    year: year,
    month: month,
    day: day,
  }
}

export const calMonth = (date1, date2) => {
  const start = new Date(date1)

  const yearStart = start.getFullYear()
  const monthStart = start.getMonth()
  const dateStart = start.getDate()

  const end = date2 ? new Date(date2) : new Date()

  const yearEnd = end.getFullYear()
  const monthEnd = end.getMonth()
  const dateEnd = end.getDate()

  let month = (yearEnd - yearStart) * 12
  month += monthEnd - monthStart

  if (dateEnd < dateStart) {
    month--
  }

  return {
    month: month,
  }
}

export const calDay = (date1, date2) => {
  const start = new Date(date1)

  const yearStart = start.getFullYear()
  const monthStart = start.getMonth()
  const dateStart = start.getDate()

  const end = date2 ? new Date(date2) : new Date()

  const yearEnd = end.getFullYear()
  const monthEnd = end.getMonth()
  const dateEnd = end.getDate()

  const utcStart = Date.UTC(yearStart, monthStart, dateStart)
  const utcEnd = Date.UTC(yearEnd, monthEnd, dateEnd)

  let day = Math.floor((utcEnd - utcStart) / (1000 * 60 * 60 * 24))
  return {
    day: day,
  }
}

const subtractYears = (date, years) => {
  date.setFullYear(date.getFullYear() - years)
  return date
}

export const calAgeToDate = (age) => {
  const date = new Date()
  const newDate = subtractYears(date, age)
  return dayjs(newDate).format('YYYY-MM-DD')
}

export const isDateValid = (value) => {
  if (typeof value !== 'string') return false
  if (isNumber(value)) return false
  return !isNaN(new Date(value))
}
